import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const faqs = [
  {
    q: "What exactly does Silent Sentry do?",
    a: "We are a vendor-neutral technology advisory and brokerage. We assess your environment, design the right solution architecture, evaluate 400+ suppliers on your behalf, negotiate contracts, and stay engaged through deployment and beyond — across cybersecurity, cloud, AI, networking, communications, and IoT.",
  },
  {
    q: "How much do your advisory services cost?",
    a: "Nothing. Our compensation comes from the supplier you ultimately select — the same way an insurance broker works. You pay the same (often less, thanks to our negotiating leverage) as you would going direct, and you gain an expert advocate at no cost.",
  },
  {
    q: "Are you biased toward specific vendors?",
    a: "No. We are supplier-agnostic by design. Because we can source from 400+ providers, our only incentive is a solution that actually fits your requirements, budget, and compliance mandates — not a sales quota for any single vendor.",
  },
  {
    q: "Do you replace our internal IT team or MSP?",
    a: "No — we make them stronger. We act as an extension of your team for strategy, sourcing, and negotiation, freeing your staff from vendor research and sales calls. Many of our engagements are brought to us by internal IT leaders and MSPs themselves.",
  },
  {
    q: "Which compliance frameworks do you support?",
    a: "We architect solutions aligned to NIST 800-53, CMMC, HIPAA, and PCI-DSS, with deep experience in state government and defense-sector requirements. Compliance mandates are captured in our intake process and drive every recommendation we make.",
  },
  {
    q: "How does the engagement process work?",
    a: "Five steps: Discover (assess your environment and objectives), Design (defense-first architecture), Negotiate (supplier evaluation and pricing), Deploy (project oversight through go-live), and Optimize (ongoing lifecycle support and reviews).",
  },
  {
    q: "What size organizations do you work with?",
    a: "From growing mid-market companies to state agencies and federal-sector contractors. If technology decisions carry real budget, risk, or compliance weight in your organization, we can add value.",
  },
  {
    q: "What happens after I submit the intake form?",
    a: "You receive an immediate confirmation email. Our advisory practice reviews your details and contacts you via your preferred method — typically within one business day — to schedule a confidential, no-obligation strategy assessment.",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#0B1035] border-y border-white/10">
    <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    <div className="max-w-4xl mx-auto px-6 md:px-12">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">FAQ</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white">
        Questions we hear before every engagement.
      </h2>
      <Accordion type="single" collapsible className="mt-12">
        {faqs.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-white hover:text-cyan-300 hover:no-underline font-heading text-base sm:text-lg font-medium py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="text-slate-400 text-sm leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
